module.exports = __webpack_public_path__ + "static/media/orientalCollegeLogo.96e4d4bf.png";